
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/general",
      function () {
        return require("private-next-pages/[company]/settings/general.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/settings/general"])
      });
    }
  